module.exports = __webpack_public_path__ + "img/home_bg_leaf.fb11ff05.png";